export default __webpack_public_path__ + "static/media/empty.68f23e55.svg";